import React from "react";
import { Link } from "react-router-dom";
import "./ErrorPage.css";
import Banner from "../Banner/Banner";

const ErrorPage = () => {
  const BASEURL = process.env.REACT_APP_SOMPROP_BASE_URL;

  return (
    <>
      <Banner />
      <div className="pageNotFound">
        <div className="container text-center ">
          <div className="row">
            <h2>404</h2>
            <h4>OPPS! PAGE NOT FOUND</h4>
            <p>
              Sorry, The Page You are looking for doesn't exists or has been
              removed.
            </p>

            <div className="pt-4 notFoundBtn">
              <Link
                to={BASEURL}
                className="btn btn-purple me-2 d-inline-flex align-items-center justify-content-center py-2"
              >
                Home
              </Link>

              <Link
                to="contact"
                className="btn btn-purple mx-2 d-inline-flex align-items-center justify-content-center py-2"
              >
                Contact
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ErrorPage;
